module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/uploadidcardimage/asset/back.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/uploadidcardimage/asset/back.png
// module id = 1079
// module chunks = 418